import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRsVersionStore = defineStore('rsVersion', () => {
  const rsVersion = ref('')

  return {
    rsVersion
  }
})
